export const resourceConfigs = [
  {
    key: 'blogs',
    label: 'Blog Posts',
    endpoint: '/blogs',
    idField: 'post_id',
    listQuery: '?limit=100',
    columns: [
      { name: 'title', label: 'Title' },
      { name: 'category', label: 'Category' },
      { name: 'is_sponsored', label: 'Sponsored' },
    ],
    defaults: { author_id: 'author-1', author_name: 'Dr. Sarah Mitchell', read_time: 5 },
    fields: [
      { name: 'title', label: 'Title', type: 'text', required: true },
      { name: 'slug', label: 'Slug (URL)', type: 'text', required: true },
      { name: 'excerpt', label: 'Excerpt', type: 'textarea', required: true },
      { name: 'content', label: 'Content (HTML)', type: 'textarea', rows: 12, required: true, mono: true },
      { name: 'author_name', label: 'Author Name', type: 'text', required: true },
      { name: 'category', label: 'Category', type: 'text', required: true },
      { name: 'tags', label: 'Tags (comma-separated)', type: 'csv' },
      { name: 'featured_image', label: 'Featured Image URL', type: 'text', required: true },
      { name: 'meta_title', label: 'Meta Title (SEO)', type: 'text', required: true },
      { name: 'meta_description', label: 'Meta Description (SEO)', type: 'textarea', required: true },
      { name: 'read_time', label: 'Read Time (minutes)', type: 'number' },
      { name: 'is_featured', label: 'Featured Post', type: 'checkbox' },
      { name: 'is_sponsored', label: 'Sponsored Post', type: 'checkbox' },
    ],
  },
  {
    key: 'universities',
    label: 'Universities',
    endpoint: '/universities',
    idField: 'university_id',
    listQuery: '?limit=100',
    columns: [
      { name: 'name', label: 'Name' },
      { name: 'country', label: 'Country' },
      { name: 'ranking_global', label: 'Global Rank' },
    ],
    defaults: { tuition_min: 0, tuition_max: 0, acceptance_rate: 0, ranking_global: 0, ranking_national: 0 },
    fields: [
      { name: 'name', label: 'Name', type: 'text', required: true },
      { name: 'country', label: 'Country', type: 'text', required: true },
      { name: 'region', label: 'Region', type: 'text', required: true },
      { name: 'logo', label: 'Logo URL', type: 'text', required: true },
      { name: 'banner_image', label: 'Banner Image URL', type: 'text', required: true },
      { name: 'description', label: 'Description', type: 'textarea', required: true },
      { name: 'tuition_min', label: 'Tuition Min ($)', type: 'number' },
      { name: 'tuition_max', label: 'Tuition Max ($)', type: 'number' },
      { name: 'acceptance_rate', label: 'Acceptance Rate (%)', type: 'number', float: true },
      { name: 'ranking_global', label: 'Global Ranking', type: 'number' },
      { name: 'ranking_national', label: 'National Ranking', type: 'number' },
      { name: 'programs', label: 'Programs (comma-separated)', type: 'csv' },
      { name: 'highlights', label: 'Highlights (comma-separated)', type: 'csv' },
      { name: 'website', label: 'Website URL', type: 'text', required: true },
    ],
  },
  {
    key: 'scholarships',
    label: 'Scholarships',
    endpoint: '/scholarships',
    idField: 'scholarship_id',
    listQuery: '?limit=100',
    columns: [
      { name: 'title', label: 'Title' },
      { name: 'university', label: 'University' },
      { name: 'deadline', label: 'Deadline' },
    ],
    defaults: {},
    fields: [
      { name: 'title', label: 'Title', type: 'text', required: true },
      { name: 'amount', label: 'Amount', type: 'text', required: true },
      { name: 'deadline', label: 'Deadline', type: 'text', required: true },
      { name: 'eligibility', label: 'Eligibility', type: 'textarea', required: true },
      { name: 'university', label: 'University', type: 'text', required: true },
      { name: 'country', label: 'Country', type: 'text', required: true },
      { name: 'description', label: 'Description', type: 'textarea', required: true },
      { name: 'application_link', label: 'Application Link', type: 'text', required: true },
    ],
  },
  {
    key: 'courses',
    label: 'Courses',
    endpoint: '/courses',
    idField: 'course_id',
    listQuery: '?limit=100',
    columns: [
      { name: 'title', label: 'Title' },
      { name: 'university', label: 'University' },
      { name: 'degree_level', label: 'Level' },
    ],
    defaults: { price: 0 },
    fields: [
      { name: 'title', label: 'Title', type: 'text', required: true },
      { name: 'university', label: 'University', type: 'text', required: true },
      { name: 'course_type', label: 'Course Type (online/offline)', type: 'text', required: true },
      { name: 'degree_level', label: 'Degree Level', type: 'text', required: true },
      { name: 'duration', label: 'Duration', type: 'text', required: true },
      { name: 'price', label: 'Price ($)', type: 'number' },
      { name: 'category', label: 'Category', type: 'text', required: true },
      { name: 'skills', label: 'Skills (comma-separated)', type: 'csv' },
      { name: 'description', label: 'Description', type: 'textarea', required: true },
      { name: 'image', label: 'Image URL', type: 'text', required: true },
    ],
  },
  {
    key: 'categories',
    label: 'Categories',
    endpoint: '/categories',
    idField: 'category_id',
    listQuery: '',
    columns: [
      { name: 'name', label: 'Name' },
      { name: 'slug', label: 'Slug' },
    ],
    defaults: {},
    fields: [
      { name: 'name', label: 'Name', type: 'text', required: true },
      { name: 'slug', label: 'Slug', type: 'text', required: true },
      { name: 'description', label: 'Description', type: 'textarea', required: true },
    ],
  },
];
